




































import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/assets/logo.svg';
import Icon from '@/components/Icon.vue';
import variables from '@/support/variables';
import LanguageService from '@/services/language';

@Component({
  components: {
    Icon,
    Logo,
  },
})
export default class Navigation extends Vue {
  languageService = new LanguageService();

  showMobileNav = false;

  get languages() {
    return variables.languages;
  }

  toggleMobileNav() {
    this.showMobileNav = !this.showMobileNav;
  }

  hideMobileNav() {
    setTimeout(() => {
      this.showMobileNav = false;
    }, 150);
  }

  setLanguage(language: any) {
    this.languageService.language = language.code;
    this.hideMobileNav();
  }
}
